<template>
  <div id="app">

    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    document.title = 'JHL — Opiskelijalomake'
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;700');

html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video {
  font-size:100%;
  font:inherit;
  padding:0;
  border:0;
  margin:0;
  vertical-align:baseline;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
}

html, body {
  font-size: 18px;
  line-height: 1.5;
  font-family: 'Ubuntu', sans-serif, "Apple Color Emoji","Segoe UI Emoji", "Segoe UI Symbol";
  color: #202020;
  font-weight: 400;
  background: white;
}

button, input, textarea, select {
  font-family: 'Roboto', sans-serif, "Apple Color Emoji","Segoe UI Emoji", "Segoe UI Symbol";
  outline: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  //-webkit-appearance: none;
  border-radius: 0;
}

button {
  outline: none;
  font-family: 'Ubuntu', sans-serif, "Apple Color Emoji","Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 18px;
  background: none;
  border: none;
}

input[type=text],input[type=password] {
  width: 100%;
  height: 52px;
  border: 0;
  border-radius: 4px;
  outline: none;
  background: #f8f8f8;
  font-family: 'Ubuntu', sans-serif, "Apple Color Emoji","Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 18px;
  padding: 0 20px;
  margin: 0 0 30px 0;
}

</style>
